import React, { useEffect, useState } from 'react';
import './onboarding-tooltip.scss';

const OnboardingTooltip = ({
    tooltip: { text, left, top, step, arrowPosition },
    allStepsNumber,
    onGotItClicked,
    onSkipClicked
}) => {
    const [tooltipStyle, setTooltipStyle] = useState({ left, top });
    useEffect(() => {
        setTooltipStyle({ left, top });
    }, [left, top]);

    return (
        <>
            <div className="overlay" />
            <div className={`glu-tooltip-body arrow-${arrowPosition}`} style={tooltipStyle}>
                <div className="glu-tooltip-step">{step} of {allStepsNumber}</div>
                <div className="glu-tooltip-text">
                    {text}
                </div>
                <div className="glu-tooltip-actions">
                    <button className="glu-tooltip-skip" onClick={onSkipClicked}>Skip</button>
                    <button className="glu-tooltip-got-it" onClick={onGotItClicked}>Got It</button>
                </div>
            </div>
        </>
    );
};

export default OnboardingTooltip;
